import { BaseDao } from './BaseDao';
import { ApiHelper } from '../apiHelper';
import { ConstantMan } from '../constantMan';
import { ScheduledReport } from '../../models/scheduledReport';
import { Observable } from 'rxjs';

export class ScheduledReportDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.SCHEDULEDREPORT, apiHelper);
  }
}
